<template>
  <v-app>
    <print-view
      @close="goHome"
      :items="items"
      :contactMode="contactMode"
      :printMode="true"
      :pages="[-1]"
    >
      <print-view-formatted-header
        style="max-height: 210px;"
        :section="section"
      />
    </print-view>
  </v-app>
</template>

<script>
import PrintView from "../views/reports/PrintView";
import PrintViewFormattedHeader from "../views/reports/PrintViewFormattedHeader";
export default {
  components: {
    PrintView,
    PrintViewFormattedHeader
    // PrintViewHeader
  },
  data() {
    return {
      items: [],
      contactMode: "",
      printType: "",
      section: {
        top: {
          title: "",
          subtitle: ""
        },
        middle: {
          title: "",
          subtitle: ""
        },
        bottom: {
          subtitle: []
        }
      }
    };
  },
  created() {
    this.printType = this.$route.query.type;
    this.populateContent();
    let section = JSON.parse(localStorage.printHeader);
    if (section) {
      this.section = section.section;
    }
  },
  methods: {
    goHome: function() {
      localStorage.printContactMode = "";
      localStorage.printItems = [];
      window.close();
    },
    populateContent: async function() {
      if (localStorage.printContactMode) {
        this.contactMode = localStorage.printContactMode;
      }
      if (localStorage.printItems) {
        this.items = (await JSON.parse(localStorage.printItems)) || [];
      }
    }
  }
};
</script>
<style scoped lang="css">
h1 {
  font-size: 150px;
  line-height: 150px;
  font-weight: 700;
  color: #252932;
  text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px,
    rgba(61, 61, 61, 0.3) 3px 3px;
}
@media print {
  .footer,
  #non-printable {
    display: none !important;
  }
  #printable {
    display: block;
  }
}
</style>
